import uuid from 'powtoon-commons/utils/uuid'
import {isNil, pick, pickBy} from 'lodash'
import {isFlippableItem} from 'powtoon-document'
import {DEFAULT_SPRITE_WIDTH_AND_HEIGHT} from 'powtoon-document/consts'

import typeProps from './typeProps'

export default function lib2docItem(libraryItem, options) {
  return {
    id: uuid(),
    contentItemId: libraryItem.id,

    ...pick(libraryItem, 'itemType', 'assetType', 'sourcePanel'),

    rotation: 0,
    opacity: 1,
    ...pickBy({isFlipped: libraryItem.isFlipped || false}, val => isFlippableItem(libraryItem)),
    ...pickBy({colors: libraryItem.colors || []}, val => libraryItem.isColorable),
    ...pickBy({tint: libraryItem.tint}, val => libraryItem.isTintable && !isNil(val)),

    width: libraryItem.width || DEFAULT_SPRITE_WIDTH_AND_HEIGHT,
    height: libraryItem.height || DEFAULT_SPRITE_WIDTH_AND_HEIGHT,
    
    ...typeProps(libraryItem, options),
    ...options?.extraSpriteData
  }
}
